import info from './info'
import menu from './menu'
import table from './table'

export default{
    userId: 'Nutzer {id}',
    newUser: 'Neuer Nutzer',
    createUser: 'Neuen Nutzer anlegen',

    deleteUser: 'Nutzer löschen',
    deleteUserText:
        'Möchtest du den Nutzer wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOtherUserText:
        'Möchtest du den Nutzer {name} wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOwnUserText:
        'Möchtest du deinen Account wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    transferDataText: "Angelegte Vorgänge & Formulare müssen auf einen Nutzer mit der gleichen Organisation übertragen werden. Bitte wähle einen Nutzer aus.",
    noSelectableUsers: 'Es gibt keine Nutzer, die du auswählen kannst. Mögliche Ursachen sind:\n- Du bist der einzige Nutzer in deiner Organisation.\n- Du hast mit der aktuellen Rolle keine Berechtigung, um andere Nutzer aus dieser Organisation zu sehen.',
    deleteUserSuccess: 'Nutzer wurde erfolgreich gelöscht.',
    deleteUserError: 'Der Nutzer konnte nicht gelöscht werden.',

    resendEmailVerificationMailSuccess: 'Verifizierungsmail wurde erfolgreich versendet.',
    resendEmailVerificationMailError: 'Verifizierungsmail konnte nicht versendet werden.',
    impersonateSuccess: 'Erfolgreich als gewählter Nutzer unterwegs.',
    impersonateError: 'Identität konnte nicht übernommen werden.',
    impersonateBanner: 'Als {fullname} {organisation_name} unterwegs.',
    leaveImpersonationSuccess: 'Identität wurde erfolgreich zurückgesetzt.',
    leaveImpersonationError: 'Identität konnte nicht zurückgesetzt werden.',
    leaveImpersonationLink: 'Zurück',
    updateSuccess: 'Nutzer wurde erfolgreich gespeichert',
    saveSuccess: 'Nutzer wurde erfolgreich gespeichert',
    welcome: 'Willkommen {name}!',

    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    profileImage: 'Profilbild',
    profile_image_id: 'Profilbild ID',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    current_organisation_id: 'Aktive Organisation',

    signatureInfo: 'Mit dieser Unterschrift können Sammellisten, die bei der Auswertung erstellt werden, unterschrieben werden.',
    createSignature: 'Signatur erstellen',
    signed_at: 'Unterschrieben am {date}',

    acceptSignature: {
        title: 'Digitale Unterschrift',
        description: 'Unterschreibe direkt hier in der App.',
        sign: 'Weitergabevertrag unterschreiben',
        scanQrCode: 'Scanne den QR-Code um zu unterschreiben.',
        missingScanningDevice: 'Kein Gerät zum einscannen?',
        signOnThisDevice: 'Auf diesem Gerät unterschreiben'
    },

    signatureTitle: 'Unterschrift',

    deleteSignature: 'Unterschrift löschen',
    deleteSignatureText: 'Möchtest du die Unterschrift wirklich löschen?',
    deleteSignatureSuccess: 'Die Unterschrift wurde erfolgreich gelöscht.',
    deleteSignatureError: 'Die Unterschrift konnte nicht gelöscht werden.',


    organisation_id: 'Verknüpfte Organisation',
    user_id: 'Verknüpfter Nutzer',
    role_name: 'Verknüpfte Rolle',
    organisation_user_id: 'Verknüpfung',
    amos_web_connection_active: 'amosWEB Verbindung aktiv',

    confirmLeave: 'Du hast nicht gespeicherte Änderungen. Möchtest du die Seite wirklich verlassen?',

    info,
    menu,
    table,
}